import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";
import { hasSessionEvents } from "@/shared/domain/orgs";
import { useOrgEventModel } from "@/shared/domain/orgs/hooks";

import { STALE_QUERY_TIMEOUT_MSEC } from "./constants";

export const getQueryKey = (orgId?: string) => {
  return ["orgEventMetadataKeys", orgId];
};

export function useEventMetadataKeys(
  orgId?: string,
): UseQueryResult<string[], Error> {
  const { events } = useDomainServices();
  const { currentOrganization } = useAuth();
  const canonicalOrgId = orgId || currentOrganization?.org_id;
  const includeSessionEvents = hasSessionEvents(
    useOrgEventModel(canonicalOrgId),
  );

  return useQuery({
    queryKey: [...getQueryKey(canonicalOrgId), includeSessionEvents],
    queryFn: ({ signal }) => {
      return events.getMetadataKeysForOrg({
        abortSignal: signal,
        resourceOwnerId: canonicalOrgId,
        includeSessionEvents,
      });
    },
    staleTime: STALE_QUERY_TIMEOUT_MSEC,
    enabled: canonicalOrgId !== undefined,
  });
}
